module.exports = __webpack_public_path__ + "static/media/indecision.9ac7055f.jpg";